import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'shared/lib/SureDesignSystem';
import patternSrc from './assets/pattern.png';

import styles from './AuthLayout.module.css';

const propTypes = {
  children: PropTypes.element.isRequired,
  description: PropTypes.string.isRequired,
  handleFacebookSignIn: PropTypes.func,
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  handleFacebookSignIn: null,
};

const AuthLayout = props => {
  const { children, description, handleFacebookSignIn, title } = props;

  return (
    <section className={styles.container}>
      <div className={styles.pattern_container}>
        <img className={styles.pattern} src={patternSrc} alt="bright pattern" />
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>

        <p className={styles.description}>{description}</p>

        {!!handleFacebookSignIn && (
          <>
            <Button
              className={styles.facebook_button}
              onClick={handleFacebookSignIn}
            >
              Continue with Facebook
            </Button>

            <div className={styles.divider}>
              <p className={styles.dividerText}>or</p>
            </div>
          </>
        )}

        {children}
      </div>
    </section>
  );
};

AuthLayout.propTypes = propTypes;
AuthLayout.defaultProps = defaultProps;

export default AuthLayout;
